
<style >
.is_valid { color: rgba(136, 152, 170, 0.8); }
.is_valid:before { width: 50%; }
li { 
	margin-bottom: 8px;
	color: #525f7f;
	position: relative;
}

li:before {
  content: "";
	width: 0%; height: 2px;
	background: #2ecc71;
	position: absolute;
	left: 0; top: 50%;
	display: block;
	transition: all .6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
</style>
<script>
    export default {
         props: {
              model: {
      type: Object,
      default: () => {}
    }
         },
      data:() => ({
          type:'password',
        hasVisiblePassword: false,
           contains_eight_characters: false,
          contains_number: false,
          contains_uppercase: false,
          contains_special_character: false,
      }),
      computed: {
        
      },
       methods: {
changeType()
{
    debugger
    if(this.type=='password')
       this.type='text'
    else
       this.type='password'

},
    checkPassword() {
      debugger
      this.password_length = this.model.Password.length;
			const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
			
      if (this.password_length > 8) {
        this.contains_eight_characters = true;
      } else {
        this.contains_eight_characters = false;
			}
			
      this.contains_number = /\d/.test(this.model.Password);
      this.contains_uppercase = /[A-Z]/.test(this.model.Password);
			this.contains_special_character = format.test(this.model.Password);
      
      if (this.contains_eight_characters === true &&
					this.contains_special_character === true &&
					this.contains_uppercase === true &&
					this.contains_number === true) {
						this.valid_password = true;			
      } else {
        this.valid_password = false;
      }
    
  },
       }
    }
    </script>
  <template>
    <div class="center content-inputs">
    
            <vs-input
                :type="type"
                v-model="model.Password"
                :label-placeholder="$t('PasswordRequired')"
                icon-after
                class="mt-10  w-full"
                icon="icon icon-eye-off"
                icon-pack="feather"
                @icon-click="changeType()"
                @input="checkPassword"
                />
       
      <ul class="ml-2 mt-3">
			<li v-bind:class="{ is_valid: contains_eight_characters }">8 {{$t('Characters')}}</li>
			<li v-bind:class="{ is_valid: contains_number }">{{$t('ContainsNumber')}}</li>
			<li v-bind:class="{ is_valid: contains_uppercase }">{{$t('ContainsUppercase')}}</li>
			<li v-bind:class="{ is_valid: contains_special_character }">{{$t('ContainsSpecialCharacter')}}</li>
		</ul>
    </div>
  </template>
  